import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: 0.08 * i, ease: EASE } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, baseDelay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    {...(onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span className={`block ${lineClassName}`} variants={lineVariants} custom={i + baseDelay}>
          {line}
        </motion.span>
      </span>
    ))}
  </motion.div>
);

export const Eyebrow = ({ children, index }) => (
  <div className="flex items-center gap-3 font-mono text-xs font-bold uppercase tracking-[0.22em] text-brand-400">
    {index && <span className="text-zinc-400">{index}</span>}
    <span className="h-px w-8 bg-brand-400/70" />
    <span>{children}</span>
  </div>
);
